// components/SelectDropdown.js
import React, { useState } from "react";

const SelectDropdown = ({
    label,
    value,
    onChange,
    placeholder = "Select an option",
    children,
}) => {
    const [isOpen, setIsOpen] = useState(false);

    return (
        <div className="flex flex-col w-full relative">
            {label && (
                <label className="mb-2 text-sm font-medium text-gray-700">
                    {label}
                </label>
            )}

            <div className="relative">
                <select
                    value={value}
                    onChange={(e) => onChange(e.target.value)}
                    onFocus={() => setIsOpen(true)}
                    onBlur={() => setIsOpen(false)}
                    className="w-full px-4 py-2 pr-10 border border-gray-300 rounded-xs shadow-xs focus:outline-hidden focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all bg-white text-gray-700 appearance-none"
                >
                    {placeholder && (
                        <option value="" disabled hidden>
                            {placeholder}
                        </option>
                    )}
                    {children}
                </select>

                {/* Custom Arrow (pure SVG) */}
                <svg
                    className={`absolute right-3 top-1/2 -translate-y-1/2 h-5 w-5 text-gray-500 transition-transform duration-200 ${
                        isOpen ? "rotate-180" : "rotate-0"
                    }`}
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                >
                    <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M19 9l-7 7-7-7"
                    />
                </svg>
            </div>
        </div>
    );
};

export default SelectDropdown;
